interface IMessages {
    [index: string]: string
}

const validationMessages: IMessages = {
    us: 'Please enter a valid email, such as example@example.com',
    es: 'Por favor ingresa un correo válido, por ej. example@example.com'
}

export const getIsValidEmailAddress = (email: string, language = 'us') => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase()) || validationMessages[language]
}

export const validateEmailForForm = (language = 'us') => {
    return (email: string): true | string => {
        const result = getIsValidEmailAddress(email, language)
        return result === true ? true : validationMessages[language]
    }
}

export const validateEmailsMatch = (watch: (name: string) => string) => {
    return (confirmationEmail: string): true | string => {
        const originalEmail = watch('receiver_email')
        return confirmationEmail === originalEmail || 'Los correos no coinciden'
    }
}
